import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import { WindowMU } from "app/types/WindowMU";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
declare var window: WindowMU


export async function cadastroCliente(codigoCliente: number, forcarAtualizar: boolean = false, foraOrcamento: boolean = false) {

    const identificadorOrcamento = foraOrcamento ? null : store.getState().orcamento.IdentificadorOrcamento
    const resultado = await microuniversoApi.Cliente.ObterDadosCadastroCliente(codigoCliente, identificadorOrcamento, forcarAtualizar)
    // const orcamentoLegado = window?.orcamentoController?.model
    if (resultado && !("HasErrors" in resultado)) {
        store.dispatch(sobrescreverInformacoesAction({ Cliente: resultado.Cliente }))

        //orcamentoLegado?.set("Cliente", resultado.Cliente)
    }
    
    return resultado;
}
